/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=d35f4360&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d35f4360"]])

export default __exports__